// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"14b72434","453":"be6ff611","824":"187e54ae"}[chunkId] + ".chunk.js";
};